import { Pharmacy } from "~/common/types/pharmacies";

export const formatPharmacyInfo = (pharmacy: Pharmacy) =>
  `${pharmacy.name} - ${pharmacy.address.street} - ${pharmacy.address.city}`;
